/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


import AttributeCollection from 'astro/util/attribute/collection';
import InfluenceCollection from 'astro/util/influence/collection';


export default class
{
  constructor (scope)
  {
    this.scope = scope;

    this.influenceCollection = new InfluenceCollection();
    this.resistanceCollection = new AttributeCollection();

    this.influenceRange = 1;
    this.influenceStrength = 1;

    this.signalJamming = false;
    this.projectileShield = false;

    this.platformSource = null;
    this.influenceRedirect = null;

    this.influenceDisables = [];
    this.influenceDirections = [];
  }


  installInfluence (influence)
  {
    this.influenceCollection.push(influence);
  }


  installResistance (resistance)
  {
    this.resistanceCollection.push(resistance);
  }


  setInfluenceRange (range)
  {
    this.influenceRange = range;
  }


  setInfluenceStrength (strength)
  {
    this.influenceStrength = strength;
  }


  setPlatformSource (source)
  {
    this.platformSource = source;
  }


  setInfluenceRedirect (redirect)
  {
    this.influenceRedirect = redirect;
  }


  setInfluenceDisables (disables)
  {
    this.influenceDisables = disables;
  }


  setInfluenceDirections (directions)
  {
    this.influenceDirections = directions;
  }


  enableSignalJamming()
  {
    this.signalJamming = true;
  }


  enableProjectileShield()
  {
    this.projectileShield = true;
  }


  getInfluence (user)
  {
    let ratio = 1.0 - this.getResistance(user);

    return Math.floor(this.influenceCollection.getInfluence(user) * ratio);
  }


  getResistance (user)
  {
    return this.resistanceCollection.getMaxValue(user, 'resistance-interaction');
  }


  getInfluenceRange ()
  {
    return this.influenceRange;
  }


  getInfluenceStrength ()
  {
    return this.influenceStrength;
  }


  getInfluenceUser ()
  {
    return this.scope.getCass().getUser();
  }


  getPlatformSource ()
  {
    return this.platformSource;
  }


  getInfluenceRedirect ()
  {
    return this.influenceRedirect;
  }


  getInfluenceDirections ()
  {
    return this.influenceDirections;
  }


  isSignalJamming ()
  {
    return this.signalJamming;
  }


  isProjectileShield ()
  {
    return this.projectileShield;
  }


  eachInfluence (callback)
  {
    return this.influenceCollection.eachInfluence(callback);
  }


  getInfluenceUsers ()
  {
    return this.influenceCollection.getUsers();
  }


  getInfluenceWinner ()
  {
    let winner = this.scope.getSector().getCass().getUser();

    this.influenceCollection.eachInfluenceUser(user =>
    {
      if (this.getInfluence(user) > this.getInfluence(winner))
      {
        winner = user;
      }
    });

    return winner;
  }


  getInfluenceAdvantage ()
  {
    const owner = this.scope.getCass().getUser();

    let advantage = Number.MAX_SAFE_INTEGER;

    const ownerInfluence = this.getInfluence(owner);

    this.influenceCollection.eachInfluenceUser(user =>
    {
      let newAdvantage = ownerInfluence - this.getInfluence(user);

      if (user !== owner && newAdvantage < advantage)
      {
        advantage = newAdvantage;
      }
    });

    if (advantage === Number.MAX_SAFE_INTEGER)
    {
      advantage = ownerInfluence;
    }

    if (this.scope.getSector().getCass().getUser() !== owner)
    {
      --advantage;
    }

    return advantage;
  }


  isInfluenceDisabled (coords)
  {
    for (const location of this.influenceDisables)
    {
      if (coords === location.id)
      {
        return true;
      }
    }

    return false;
  }


};
